;(function () {
  'use strict'

  angular
    .module('contrast.date')
    .directive('csDateRangePicker', csDateRangePicker)

  function csDateRangePicker(
    $,
    $timeout,
    $rootScope,
    $document,
    csDateRangePickerFormats
  ) {
    'ngInject'

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'views/cs-date-range-picker.html',
      controller: 'csDateRangePickerCtrl',
      controllerAs: 'csDateRangePickerCtrl',
      require: ['^ngModel', '^csDateRangePicker'],
      bindToController: {
        onCancel: '&',
        onHide: '&',
        extraOptions: '=?'
      },
      scope: {},
      link: function (scope, elem, attrs, ctrls) {
        var ngModelCtrl = ctrls[0]
        var csDateRangePickerCtrl = ctrls[1]

        // Determine if optional functionality is enabled/disabled
        csDateRangePickerCtrl.timePicker =
          attrs.hasOwnProperty('timePicker') &&
          !angular.isUndefined(attrs.timePicker)
            ? true
            : undefined

        csDateRangePickerCtrl.propagateModelChange = function () {
          // Since the date and time model values are separate, we need to sync them
          _syncTimeToDate(csDateRangePickerCtrl.model, 'start')
          _syncTimeToDate(csDateRangePickerCtrl.model, 'end')

          $timeout(function () {
            ngModelCtrl.$setViewValue(csDateRangePickerCtrl.model)
          })
        }

        csDateRangePickerCtrl.highlightDaysInRange = function () {
          // This is a hack to refresh the uib-datepicker DOM
          $rootScope.$broadcast('refreshDatepickers')
          $timeout(function () {
            _highlight(
              elem,
              csDateRangePickerCtrl.model,
              csDateRangePickerCtrl.datePickerOpts.maxDate,
              'start'
            )
            _highlight(
              elem,
              csDateRangePickerCtrl.model,
              csDateRangePickerCtrl.datePickerOpts.maxDate,
              'end'
            )
          })
        }

        $document.on('click', onClick)

        function onClick(e) {
          var $target = $(e.target)
          var a = $target.closest('.cs-date-range-picker')
          // b is necessary b/c of uib-datepicker... I think the buttons aren't children of .cs-date-range-picker
          // after a refresh occurs. There is probably a better way to do this, but for now...
          var b = $target.closest('button.btn.btn-default.btn-sm')
          // c is for preventing the range picker from disappearing immediately after it is shown
          var c = $target.closest('.cs-date-range-picker-primary')
          // prevent from disappearing when month or year btns are clicked
          var d = $target.closest('.uib-monthpicker')
          e = $target.closest('.uib-yearpicker')
          if (!a.length && !b.length && !c.length && !d.length && !e.length) {
            csDateRangePickerCtrl.hide()
            if (angular.isFunction(csDateRangePickerCtrl.onHide)) {
              csDateRangePickerCtrl.onHide()
            }
          }
        }

        scope.$on('$destroy', function () {
          $document.off('click', onClick)
        })

        $timeout(function () {
          if (
            angular.isObject(ngModelCtrl.$modelValue) &&
            ngModelCtrl.$modelValue.startDate !== null &&
            ngModelCtrl.$modelValue.endDate !== null
          ) {
            csDateRangePickerCtrl.setModel(ngModelCtrl.$modelValue)
          }
          csDateRangePickerCtrl.activate()
          csDateRangePickerCtrl.highlightDaysInRange()
        })
        csDateRangePickerCtrl.activate()
        csDateRangePickerCtrl.highlightDaysInRange()
      }
    }

    function _highlight(elem, model, maxDate, which) {
      var daysList = []

      var calendar = elem.find('.calendars .' + which)
      var calendarTitle = calendar.find('.uib-title strong').html().trim()
      var dayPicker = calendar.find('.uib-daypicker')
      var weeks = dayPicker.find('.uib-weeks')

      var inRangeClass = 'in-range'
      var dayFormat = csDateRangePickerFormats.HIGHLIGHT_DAY_FORMAT

      weeks.each(function () {
        var $week = $(this)
        var days = $week.find('.uib-day')
        days.each(function () {
          var $day = $(this)
          var $dayBtn = $day.find('button')

          // Get string representing day number
          // Ignore .text-muted as these are the days for the prev and next month, not the current.
          var dayDate = $day.find('button span:not(.text-muted)').text()
          if (angular.isString(dayDate) && dayDate.trim() != '') {
            dayDate = parseInt(dayDate.trim(), 10)

            // Cache day number
            daysList[dayDate] = dayDate

            // Build a momentjs date for this day
            dayDate = moment(dayDate + ' ' + calendarTitle, dayFormat)

            // Highlight day if it is in-range
            if (isDateInRange(maxDate, model, dayDate)) {
              $dayBtn.addClass(inRangeClass)
            } else {
              $dayBtn.removeClass(inRangeClass)
            }
          }
        })
      })
    }

    function isDateInRange(maxDate, model, date) {
      // Ignore time
      var start = moment(model.startDate).startOf('day')
      var end = moment(model.endDate).endOf('day')
      return (
        (date.isBefore(moment(maxDate)) || date.isSame(moment(maxDate))) &&
        (date.isSame(start) ||
          (date.isAfter(start) && date.isBefore(end)) ||
          date.isSame(end))
      )
    }

    // Get diff of date and time and then add time diff to date
    // This assumes that the date values are set to beginning of the day
    function _syncTimeToDate(model, which) {
      var dateKey = which + 'Date'
      var timeKey = which + 'Time'
      var date = moment(model[dateKey]).startOf('day')
      var time = moment(model[timeKey])
      var timeBegin = moment(time).startOf('day')
      var timeDiff = time.diff(timeBegin)
      date.add(Math.abs(timeDiff))
      model[dateKey] = date
    }
  }
})()
